<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import { UserGroup } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import UserGroupForm from '@/components/user-groups/UserGroupForm.vue';
    import QueryKey from '@/enums/QueryKey';

    const props = defineProps<{
        userGroup: UserGroup;
    }>();

    const form = useForm({
        id: props.userGroup.id,
        name: props.userGroup.name,
        user_ids: props.userGroup.users.map((group) => group.id),
    });
</script>

<template>
    <DialogForm
        type="update"
        :form="form"
        :route="route('v2.user-groups.update')"
        :query-key="[QueryKey.USER_GROUPS]"
        title="user-groups.user_groups_edit"
        success-message="user-groups.updated"
        error-message="user-groups.update.error"
    >
        <UserGroupForm :form="form" />
    </DialogForm>
</template>
